module.exports = __webpack_public_path__ + "img/userD01.cfa72026.jpg";